import * as metaData from '../metaData';
import dcmjs from 'dcmjs';
import { moduleDefinitions, USRegionChild, CLINICAL_TRIAL, RadiopharmaceuticalInfoModule, } from './modules';
const dicomDictionary = dcmjs.data.DicomMetaDictionary.dictionary;
const nameMap = dcmjs.data.DicomMetaDictionary.nameMap;
export { USRegionChild, CLINICAL_TRIAL, RadiopharmaceuticalInfoModule };
export function createTagEntry(hexTag, ...groups) {
    return {
        tag: hexTag,
        groups,
        xTag: null,
        primaryGroup: null,
        name: null,
        lowerName: null,
        vr: null,
        vm: null,
    };
}
export function parseVm(vm) {
    if (vm === undefined || vm === null) {
        return null;
    }
    if (typeof vm === 'number') {
        return vm;
    }
    const n = parseInt(vm, 10);
    if (String(n) === vm) {
        return n;
    }
    return 0;
}
export function dictionaryLookup(hexTag) {
    return dicomDictionary[hexTag.toUpperCase()];
}
export function getTagCodeByName(name) {
    return mapTagInfo.get(name)?.tag;
}
export const mapModuleTags = new Map();
export const mapTagInfo = new Map();
export function addTag(name, value) {
    if (name && value.name && name !== value.name) {
        throw new Error(`Tag name provided and value don't match: ${name} !== ${value.name}`);
    }
    value.name ||= name;
    value.lowerName ||= metaData.toLowerCamelTag(name);
    Tags[name] = value;
    const { tag: hexTag } = value;
    value.primaryGroup ||= value.groups?.[0];
    const { groups } = value;
    mapTagInfo.set(name, value);
    if (hexTag) {
        value.xTag = `x${hexTag.toLowerCase()}`;
        value.tag = hexTag.toUpperCase();
        mapTagInfo.set(value.xTag, value);
        mapTagInfo.set(value.tag, value);
        if (!value.vr) {
            const dictEntry = dicomDictionary[value.tag];
            if (dictEntry) {
                value.vr = dictEntry.vr;
                value.vm = parseVm(dictEntry.vm);
            }
        }
    }
    if (groups?.length) {
        for (const group of groups) {
            let moduleEntries = mapModuleTags.get(group);
            if (!moduleEntries) {
                moduleEntries = [value];
                mapModuleTags.set(group, moduleEntries);
                return;
            }
            const foundIndex = moduleEntries.findIndex((it) => it.name === name);
            if (foundIndex === -1) {
                moduleEntries.push(value);
            }
            else {
                moduleEntries[foundIndex] = value;
            }
        }
    }
}
export function resolveHexFromKeyword(keyword) {
    const entry = nameMap[keyword];
    if (!entry) {
        return undefined;
    }
    return entry.tag.substring(1, 5) + entry.tag.substring(6, 10);
}
export const Tags = {};
const tagGroups = new Map();
for (const [moduleName, keywords] of moduleDefinitions) {
    for (const entry of keywords) {
        const keyword = typeof entry === 'string' ? entry : entry[0];
        const hexOverride = typeof entry === 'string' ? undefined : entry[1];
        let data = tagGroups.get(keyword);
        if (!data) {
            const hex = hexOverride ?? resolveHexFromKeyword(keyword);
            data = { hex, groups: [] };
            tagGroups.set(keyword, data);
        }
        if (moduleName !== null) {
            data.groups.push(moduleName);
        }
    }
}
for (const [keyword, { hex, groups }] of tagGroups) {
    if (!hex) {
        console.warn(`Tags: keyword "${keyword}" not found in dcmjs nameMap`);
        continue;
    }
    addTag(keyword, createTagEntry(hex, ...groups));
}
